/* eslint-disable import/no-unresolved */
const Notifications = require('notifications').Notifications;
const notificationsModule = require('data/service/notifications');

const deps = [require('ngreact').name, notificationsModule.name];

const mod = angular.module('bench.ui.notifications', deps);

mod.directive('blNotificationsReact', [
  'reactDirective',
  reactDirective => reactDirective(Notifications, ['notifications'], {}, {}),
]);

// Hack to ensure updated notifications are passed to the React component
mod.component('blNotifications', {
  bindings: {},
  template: '<bl-notifications-react notifications="$ctrl.notifications"></bl-notifications-react>',
  controller: [
    'NotificationsService',
    '$scope',
    function (NotificationsService, $scope) {
      this.notifications = NotificationsService.notifications.slice();

      $scope.$watch(
        () => NotificationsService.notifications,
        notifications => {
          this.notifications = notifications.slice();
        },
        true,
      );
    },
  ],
});

module.exports = mod;
